import AXIOS from "@/axios";
import { APIResponse } from "@/types";
import {
  DownloadGroupSchoolAdminQuery,
  GroupSchoolAdminModel,
  GroupSchoolAdminQuery,
} from "@/types/group-school-admin.model";
import { removeEmptyProps } from "@/utils/constants";
import moment from "moment";

interface CreateGroupSchoolAdminResponse {
  id: string;
  login_user: string;
  login_email: string;
  one_time_token: string;
  is_email_sent: boolean;
}

interface UpdateGroupSchoolAdminResponse {
  id: string;
  login_user: string;
  login_email: string;
}

export const getAllGroupSchoolAdminService = async (query: GroupSchoolAdminQuery) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<GroupSchoolAdminModel[]>>("/sch/api/v1/group-admin/list", {
    params: removeEmptyProps(query),
  });
};

export const createGroupSchoolAdminService = async (payload: GroupSchoolAdminModel) => {
  return AXIOS.post<APIResponse<CreateGroupSchoolAdminResponse>>(
    "/sch/api/v1/group-admin/add",
    payload
  );
};

export const updateGroupSchoolAdminService = async (
  schoolId: string,
  payload: GroupSchoolAdminModel
) => {
  return AXIOS.patch<APIResponse<UpdateGroupSchoolAdminResponse>>(
    `/sch/api/v1/group-admin/update/${schoolId}`,
    payload
  );
};

export const deleteGroupSchoolAdminService = async (id: string) => {
  return AXIOS.delete<{ message: string }>(`/sch/api/v1/group-admin/delete/${id}`);
};

export const getGroupSchoolAdminService = async (id: string) => {
  return AXIOS.get<APIResponse<GroupSchoolAdminModel>>(`/sch/api/v1/group-admin/view/${id}`);
};

export const downloadGroupSchoolAdminService = async (
  type: "pdf" | "xl" | "csv",
  params: DownloadGroupSchoolAdminQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get(`/sch/api/v1/group-admin/dwnld/${type}`, {
    params: removeEmptyProps(params),
    responseType: "blob",
  });
};
